var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_29438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95418 31.0457 -0.00012207 20 -0.00012207C8.9543 -0.00012207 0 8.95418 0 19.9999C0 31.0456 8.9543 39.9999 20 39.9999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3047 23.9129C11.3047 25.3536 12.4727 26.5216 13.9134 26.5216H21.7395C21.7395 27.7222 22.7127 28.6955 23.9134 28.6955H26.522C27.7227 28.6955 28.6959 27.7222 28.6959 26.5216V23.9129H11.3047Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.913 11.3044V17.3913C28.913 18.3503 28.1328 19.1304 27.1738 19.1304V21.7391C29.5712 21.7391 31.5216 19.7886 31.5216 17.3913V11.3044H28.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2177 17.3913C10.2177 18.3503 9.4375 19.1305 8.47852 19.1305V21.7391C10.8759 21.7391 12.8263 19.7887 12.8263 17.3913V11.3044H10.2177V17.3913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11.3044H27.6087V17.3913H25V11.3044Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0873 14.7825C21.0873 15.0223 20.8923 15.2173 20.6526 15.2173C20.4129 15.2173 20.2178 15.0222 20.2178 14.7825V11.3042H17.6091V14.7825C17.6091 15.0223 17.4141 15.2173 17.1744 15.2173C16.9347 15.2173 16.7396 15.0222 16.7396 14.7825V11.3042H14.1309V14.7825C14.1309 16.4607 15.4962 17.826 17.1744 17.826C17.8207 17.826 18.4201 17.6229 18.9135 17.2779C19.4069 17.6228 20.0063 17.826 20.6527 17.826C20.7828 17.826 20.9108 17.8169 21.0366 17.8009C20.8518 18.5625 20.1659 19.1303 19.3483 19.1303V21.739C21.7457 21.739 23.6961 19.7885 23.6961 17.3912V14.7825V11.3042H21.0874V14.7825H21.0873Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1309 19.1304H18.0439V21.7391H14.1309V19.1304Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_29438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.70abd4cfa45721fef8bcec778872d6ae.svg";
export { ForwardRef as ReactComponent };